/* eslint-disable */
import { MODULE_NAME, } from './../constants';

export const GET_STATUSES = `${MODULE_NAME}/GET_STATUSES`;
export const GET_STATUSES_SUCCESS = `${MODULE_NAME}/GET_STATUSES_SUCCESS`;
export const GET_STATUSES_ERROR = `${MODULE_NAME}/GET_STATUSES_ERROR`;
